import { COPY } from "../../lib/copy";

export function AttentionBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span
      role="status"
      aria-label={COPY.badge(count)}
      className="ml-auto inline-flex min-w-5 items-center justify-center rounded-full bg-warning/15 px-1.5 text-[11px] font-semibold text-warning"
    >
      <span aria-hidden>{count > 99 ? "99+" : count}</span>
    </span>
  );
}
